// ** Icons Import
import { Circle } from 'react-feather'

export default [
    {
        id: 'student',
        title: 'Миний профайл',
        icon: <i className="fas fa-user-graduate"></i>,
        navLink: "/student",
        children: [
            {
                id: 'personal-information',
                title: 'Хувийн мэдээлэл',
                icon: <Circle size={8} />,
                navLink: "student/personal-information/"
            },
            {
                id: 'payment-information',
                title: 'Төлбөрийн мэдээлэл',
                icon: <Circle size={8} />,
                navLink: "student/payment-information"
            },
            {
                id: 'scholarship',
                title: 'Тэтгэлэг',
                icon: <Circle size={8} />,
                navLink: "student/scholarship"
            },
            {
                id: "StudentAttendance",
                title: "Оюутны ирц",
                icon: <Circle size={8} />,
                navLink: "student/student-attendance"
            },
            // {
            //     id: "ScoringSystem",
            //     title: "Онооны систем",
            //     icon: <Circle size={8} />,
            //     navLink: "student/scoring-system"
            // },
        ]
    }
]
